import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ExamsService } from '@shared/views/exams/exams.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { AuthService } from '@app/auth/auth.service';
import { Subscription } from 'rxjs';
import { ExamsFilterService } from '@shared/components/exams-filter/exams-filter.service';
import { DataView } from 'primeng/dataview';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { DatabaseService } from '@app/database/database.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit, OnDestroy {
  @Input() listExams: any[] = [];
  @Input() motivosCierre: any[];
  @Input() tipo: string;
  @Output() emitCloseExam: EventEmitter<any> = new EventEmitter<any>();
  @Output() resultadosEvent = new EventEmitter<string>();
  @Output() refreshListEvent = new EventEmitter<any>();
  display: boolean;
  prestador: string;
  subscriptionClearFilter: Subscription;
  subscription: Subscription;
  filterCountPeriodicos: number = 0;
  filterCountReevaluacion: number = 0;
  filterCountPorEnviar: number;
  sinRegistroFilter: boolean;
  filterBy = 'provinciaNombreEstudio';
  @ViewChild('dv', { static: false }) dataview: DataView;
  inputSearch: string;
  confPage: ConfPage = new ConfPage();
  resultadosElements = [{label: 'Por Defecto', value: 'pordefecto'}, {label: 'Personalizada', value: 'personalizada'}];
  resultadosValue: any;
  isOnline = true;
  hasFilters = false;
  cambioAsistencia: any;

  constructor(private examsService: ExamsService,
    private messageAlertServices: MessageAlertService,
    private examsFilterService: ExamsFilterService,
    private authService: AuthService,
    private databaseService: DatabaseService,
    private connectionService: ConnectionService) {
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
  }

  getConfigPage() {
    const type = 'configPage' + this.tipo;
    const configPage = localStorage.getItem(type);
    this.confPage = configPage ? JSON.parse(configPage) : new ConfPage();
  }

  ngOnDestroy(): void {
    this.unsubcriptionFilter();
  }

  unsubcriptionFilter() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionClearFilter) {
      this.subscriptionClearFilter.unsubscribe();
    }
    if (this.listExams.length === 0) {
      this.sinRegistroFilter = true;
    }
  }

  ngOnInit(): void {
    this.updateHasFilters();
    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;
    });
    this.authService.currentUser.subscribe(
      (user) => (this.prestador = user.modelName)
    );
    this.resultadosValue = JSON.parse(localStorage.getItem(this.tipo === 'periodicos' ? 'resultadoPeriodicos' : 'resultadoReevaluacion'));
    if (this.resultadosValue === null) {
      localStorage.setItem(this.tipo === 'periodicos' ? 'resultadoPeriodicos' : 'resultadoReevaluacion', JSON.stringify(this.resultadosElements[0]));
      this.resultadosValue = this.resultadosElements.filter((resultado) => resultado.value === 'pordefecto' ? resultado : null)[0];
    }
    this.subscriptionFilter();
    const filtro = this.examsFilterService.getLocalAdvancedFilter(this.tipo);
    this.setCount(this.tipo, filtro);
    this.setFilter();
    this.getConfigPage();
  }

  closeExam(event): void {
    this.closeExamAndEmit(event.examen, event.motivo);
  }

  subscriptionFilter(): void {
    this.subscription = this.examsFilterService.filterExams$.subscribe((res) => {
      this.setCount(res.tipo, res.data);
      setTimeout(() => {
        this.sinRegistroFilter = false;
        this.actionFilterAdvanced(res.tipo);
      }, 100);
    }
    );
    this.subscriptionClearFilter = this.examsFilterService.clearFilterExams$.subscribe(
      (res) => {
        this.clearCount(res);
      }
    );
  }

  setCount(tipo, data): void {
    if (!data) {
      return;
    }
    if (this.dataview) {
      this.dataview.paginate({ first: 0, rows: this.dataview.rows });
    }
    switch (tipo) {
      case 'periodicos':
        this.filterCountPeriodicos = this.examsFilterService.countFilter(data);
        break;
      case 'reevaluacion':
        this.filterCountReevaluacion = this.examsFilterService.countFilter(data);
        break;
      case 'porEnviar':
        this.filterCountPorEnviar = this.examsFilterService.countFilter(data);
        break;
    }
  }

  /**
   * Método para cerrar examen
   * @param examen examen a cerrar
   * @param motivo motivo de cierre
   */
  closeExamAndEmit(examen, motivo): void {
    const examenPorEnviar = { ...examen };

    this.examsService.closeExam(examen, motivo).then(data => {
      if (data?.offline) {
        examenPorEnviar.datosPorEnviar = data.obj;
        this.messageAlertServices.setMessage(0, {
          severity: 'success',
          detail: 'El ausente se registrará cuando se retome la conexión.'
        });
        this.updateList(examen, examenPorEnviar);
        this.cambioAsistencia = {asistencia:"Ausente", motivo: motivo, id: examen.id};
      } else {
        this.messageAlertServices.setMessage(0, {
          severity: 'success',
          detail: 'El ausente se registró correctamente'
        });
        this.updateList(examen, null);
        this.cambioAsistencia = {asistencia:"Ausente", motivo: motivo, id: examen.id, refreshList: true};
        
        setTimeout(() => {
          this.refreshList();
        }, 100);
      }
      const header = document.querySelector('#content') as any;
      window.scroll(0, header.offsetTop - 150);
    }).catch(error => {
      this.messageAlertServices.setMessage(0, {
        severity: 'error',
        detail: error.message
      });
      const header = document.querySelector('#content') as any;
      window.scroll(0, header.offsetTop - 150);
    });
    
  }



  /**
   * Método que se encarga de actualizar la lista y emitir evento para actualizar listas del padre (competente de tabs)
   * @param examen
   * @param examenPorEnviar
   */
  updateList(examen, examenPorEnviar?): void {
    const tempList = [...this.listExams];
    this.listExams = [];
    if (examenPorEnviar) {
      setTimeout(() => {
        this.listExams = tempList;
        this.emitEvent(examen, examenPorEnviar);
      }, 1);
    } else {
      setTimeout(() => {
        this.listExams = tempList;
        this.emitEvent(examen, null);
      }, 1);
    }
  }

  /**
   * Método que se encarga de refrescar la lista completa
   */
  refreshList(): void {
    this.refreshListEvent.emit();
  }

  /**
   * Método que se encarga de armar el objeto y emitirlo
   * @param examen
   * @param porEnviar
   */
  emitEvent(examen, porEnviar?): void {
    const objSalida = {} as any;
    objSalida.examen = examen;
    objSalida.examenPorEnviar = porEnviar;
    this.emitCloseExam.emit(objSalida);
  }

  clearCount(tipo): void {
    this.sinRegistroFilter = false;
    switch (tipo) {
      case 'periodicos':
        this.filterCountPeriodicos = null;
        this.dataview.filter(this.inputSearch);
        break;
      case 'reevaluacion':
        this.filterCountReevaluacion = null;
        this.dataview.filter(this.inputSearch);
        break;
      case 'cargados':
        this.filterCountReevaluacion = null;
        this.dataview.filter(this.inputSearch);
        break;
      case 'porEnviar':
        this.filterCountPorEnviar = null;
        this.dataview.filter(this.inputSearch);
        break;
    }
  }

  filtros(): void {
    this.examsFilterService.openSidebarFilter(this.tipo);
  }

  limpiarFiltro(): void {
    this.clearCount(this.tipo);
    this.examsFilterService.cleanFilter(this.tipo);
  }

  setFilter(): void {
    setTimeout(() => {
      switch (this.tipo) {
        case 'periodicos':
          this.filterBy = 'numeroCarpeta,id,trabajador.apellidoNombre,provinciaNombreEstudio,trabajador.numeroDocumento,esops.0.descripcion,lote.empresa.razonSocial,lote.numeroContrato,labelVigencia,lote.numeroLote';
          break;
        case 'porEnviar':
          this.filterBy = 'numeroCarpeta,id,trabajador.apellidNombre,provinciaNombreEstudio,trabajador.numeroDocumento,esops.0.descripcion,lote.empresa.razonSocial,lote.numeroContrato,datosPorEnviar.labelExamen,datosPorEnviar.labelCerrado,lote.numeroLote';
          break;
        case 'reevaluacion':
          this.filterBy =
            'numeroCarpeta,id,trabajador.apellidoNombre,provinciaNombreEstudio,trabajador.numeroDocumento,esops.0.descripcion,lote.empresa.razonSocial,lote.numeroContrato,labelVigencia,lote.numeroLote';
          break;
        default:
          this.filterBy = 'provinciaNombreEstudio,';
          break;
      }
    }, 10);
  }

  actionFilter(event): void {
    if (event.target.value === undefined || event.target.value === null) {
      this.sinRegistroFilter = false;
      return;
    }
    if (event.target.value === '') {
      this.sinRegistroFilter = false;
    }
    this.dataview.filter(event.target.value);
    setTimeout(() => {
      if (event.target.value) {
        this.sinRegistroFilter =
          this.dataview.filteredValue &&
          this.dataview.filteredValue.length <= 0;
      }
    }, 100);
  }

  actionFilterAdvanced(tipo): void {
    switch (tipo) {
      case 'periodicos':
        if (this.listExams.length > 0) {
          if (this.dataview.filterValue) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter =
              this.dataview.filteredValue &&
              this.dataview.filteredValue.length <= 0;
          }
        } else {
          if (this.dataview) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter = true;
          }
        }
        break;
      case 'reevaluacion':
        if (this.listExams.length > 0) {
          if (this.dataview.filterValue) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter =
              this.dataview.filteredValue &&
              this.dataview.filteredValue.length <= 0;
          }
        } else {
          if (this.dataview) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter = true;
          }
        }
        break;
      case 'cargados':
        if (this.listExams.length > 0) {
          this.sinRegistroFilter = false;
          if (this.dataview.filterValue) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter =
              this.dataview.filteredValue &&
              this.dataview.filteredValue.length <= 0;
          }
        } else {
          if (this.dataview) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter = true;
          }
        }
        break;
      case 'porEnviar':
        if (this.listExams.length > 0) {
          if (this.dataview.filterValue) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter =
              this.dataview.filteredValue &&
              this.dataview.filteredValue.length <= 0;
          }
        } else {
          if (this.dataview) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter = true;
          }
        }
        break;
    }
  }

  onPage(event, tipo) {
    this.confPage = event;
    const type = 'configPage' + this.tipo;
    localStorage.setItem(type, JSON.stringify(this.confPage));
  }

  async updateHasFilters() {
    if (this.tipo === 'periodicos') {
      this.hasFilters = await this.databaseService.getCountPeriodicosExamenFiltradosFromOfflineDB() > 0;
    } else {
      this.hasFilters = await this.databaseService.getCountReevaluacionExamenFiltradosFromOfflineDB() > 0;
    }
  }

  showSelectDeResultados() {
    return this.hasFilters && !this.isOnline && (this.tipo === 'periodicos' || this.tipo === 'reevaluacion');
  }

  onChangeResultados(event): void {
    this.resultadosValue = this.resultadosElements.filter((resultado) => resultado.value === event.value.value ? resultado : null)[0];
    if (this.tipo === 'periodicos') {
      localStorage.setItem('resultadoPeriodicos', JSON.stringify(this.resultadosValue));
    } else {
      localStorage.setItem('resultadoReevaluacion', JSON.stringify(this.resultadosValue));
    }
    this.resultadosEvent.emit(this.tipo);
  }

}

export class ConfPage {
  first: number;
  rows: number;

  constructor() {
    this.first = 0;
    this.rows = 5;
  }
}
